import OpenInNew from "@mui/icons-material/OpenInNew";
import Remove from "@mui/icons-material/Remove";
import { Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { DataGrid } from "components/DataGrid";
import { HoverAction } from "components/HoverAction";
import { getStatusLabel } from "encamp-shared/src/submissions";
import { prettyPrintEnumValue } from "encamp-shared/src/utils/prettyPrintEnumValue";
import { Link } from "react-router-dom";

import { CommunicationSubmission } from "../types";

export const SubmissionsDataGrid = ({
  submissions,
  removeSubmission,
}: {
  submissions: CommunicationSubmission[];
  removeSubmission: ((id: string) => void) | null;
}) => {
  const columns: GridColDef<CommunicationSubmission>[] = [
    {
      field: "title",
      headerName: "Title",
      flex: 1.5,
      minWidth: 200,
    },
    {
      field: "submissionType",
      headerName: "Type",
      flex: 0.8,
      minWidth: 120,
      valueFormatter: (value) => (value != null ? prettyPrintEnumValue(String(value)) : ""),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.8,
      minWidth: 120,
      valueFormatter: (value) => (value != null ? getStatusLabel(String(value)) : ""),
    },
    {
      field: "actions",
      type: "actions",
      getActions: ({ row }) => {
        const actions = [];
        actions.push(
          <Tooltip key="view" title="View submission">
            <Link
              to={`/staff/fulfillment/waste/submissions/${row.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>
                <HoverAction label="View" icon={<OpenInNew fontSize="small" color="primary" />} />
              </span>
            </Link>
          </Tooltip>
        );
        if (removeSubmission) {
          actions.push(
            <Tooltip key="remove" title="Remove">
              <HoverAction
                label="Remove"
                icon={<Remove fontSize="small" color="primary" />}
                onClick={() => removeSubmission(row.id)}
              />
            </Tooltip>
          );
        }
        return actions;
      },
    },
  ];

  return (
    <DataGrid
      columns={columns}
      rows={submissions}
      rowCount={submissions.length}
      loading={false}
      isRowSelectable={() => false}
      pagination={false}
      getRowId={(row) => row.id}
    />
  );
};
